// src/components/cofounder/CoFounderBubble.js
import React from 'react';
import { Brain } from 'lucide-react';
import { useCoFounder } from '../../context/CoFounderContext';

const CoFounderBubble = () => {
  const { togglePanel, isOpen, unreadInsightCount, unreadActionCount } = useCoFounder();
  const totalUnread = (unreadInsightCount || 0) + (unreadActionCount || 0);

  return (
    <button
      onClick={togglePanel}
      className={`fixed bottom-4 right-4 z-50 w-14 h-14 rounded-full
        bg-[#190192] text-white shadow-lg hover:shadow-xl
        flex items-center justify-center
        transition-all duration-300
        ${isOpen ? 'scale-0 opacity-0' : 'scale-100 opacity-100'}
        hover:bg-[#0f0075]
        ${totalUnread > 0 ? 'animate-pulse' : ''}`}
      aria-label="Open coFounder"
    >
      <Brain size={24} />
      {totalUnread > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-red-500
          text-white text-xs font-bold flex items-center justify-center
          border-2 border-white">
          {totalUnread > 9 ? '9+' : totalUnread}
        </span>
      )}
    </button>
  );
};

export default CoFounderBubble;
